import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header/Header';
import SideNav from './components/SideNav/SideNav';
import Modal from './components/Modal/Modal';
import InboundCall from './components/InboundCall/InboundCall';
import CallNotification from './components/CallNotification/CallNotification';
import HomeScreen from './components/HomeScreen/HomeScreen';
import TaskList from './components/TaskList/TaskList';
import PerformancePulse from './components/PerformancePulse/PerformancePulse';
import Gamification from './components/Gamification/Gamification';
import PersonalizedGoals from './components/PersonalizedGoals/PersonalizedGoals';
import AIAgentInstructions from './components/AIAgentInstructions/AIAgentInstructions';
import LoadManagement from './pages/LoadManagement/LoadManagement';
import ResourceOrchestration from './pages/ResourceOrchestration/ResourceOrchestration';
import FreightMasters from './pages/FreightMasters/FreightMasters';

const calls = [
  { id: 1, name: 'Sarah Mitchell', title: 'Dispatcher, FastTrack Logistics Inc.', phone: '(555) 234-5678', initials: 'SM', priority: 'high', priorityItems: 2 },
  { id: 2, name: 'James Rodriguez', title: 'Fleet Manager, Reliable Transport Co.', phone: '(555) 345-6789', initials: 'JR', priority: 'medium', priorityItems: 3 },
  { id: 3, name: 'Emily Chen', title: 'Operations Coordinator, Swift Carriers LLC', phone: '(555) 456-7890', initials: 'EC', priority: 'low', priorityItems: 1 },
];

function App() {
  const [isSideNavOpen, setIsSideNavOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeCall, setActiveCall] = useState(null);
  const [isAIAgentModalOpen, setIsAIAgentModalOpen] = useState(false);

  const toggleSideNav = () => {
    console.log('Toggling side nav');
    setIsSideNavOpen(!isSideNavOpen);
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleIncomingCall = (call) => {
    setActiveCall(call);
  };

  const handleNotificationDismiss = () => {
    setActiveCall(null);
  };

  const handleViewDetails = () => {
    setActiveCall(null);
    openModal();
  };

  const openAIAgentModal = () => {
    setIsAIAgentModalOpen(true);
  };

  const closeAIAgentModal = () => {
    setIsAIAgentModalOpen(false);
  };

  return (
    <div className="App">
      <SideNav isOpen={isSideNavOpen} toggleNav={toggleSideNav} onCall={handleIncomingCall} calls={calls} />
      <Header toggleNav={toggleSideNav} />
      <Modal show={isModalOpen} onClose={closeModal}>
        <InboundCall onClose={closeModal} />
      </Modal>
      {activeCall && (
        <CallNotification
          call={activeCall}
          onAnswer={handleNotificationDismiss}
          onViewDetails={handleViewDetails}
          onRemind={handleNotificationDismiss}
          onDismiss={handleNotificationDismiss}
          onSendToAIAgent={openAIAgentModal}
        />
      )}
      {isAIAgentModalOpen && (
        <AIAgentInstructions
          call={activeCall}
          onClose={closeAIAgentModal}
          onSend={() => {
            closeAIAgentModal();
            handleNotificationDismiss();
          }}
        />
      )}
      <div className="main-container">
        <Routes>
          <Route path="/" element={
            <>
              <HomeScreen />
              <div className="main-content">
                <div className="left-panel">
                  <TaskList />
                </div>
                <div className="right-panel">
                  <PerformancePulse />
                  <Gamification />
                  <PersonalizedGoals />
                </div>
              </div>
            </>
          } />
          <Route path="/load-management" element={<LoadManagement />} />
          <Route path="/resource-orchestration" element={<ResourceOrchestration />} />
          <Route path="/freight-masters" element={<FreightMasters />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
